import { liveQuery } from 'dexie';
import { useEffect, useState } from 'react';

/** Minimal Dexie liveQuery hook (dexie-react-hooks is a separate package). Re-subscribes when `key` changes. */
export function useLiveQuery<T>(query: () => Promise<T>, key: string): T | undefined {
  const [value, setValue] = useState<T | undefined>(undefined);
  // biome-ignore lint/correctness/useExhaustiveDependencies: the query is identified by `key`
  useEffect(() => {
    const sub = liveQuery(query).subscribe({ next: setValue, error: () => {} });
    return () => sub.unsubscribe();
  }, [key]);
  return value;
}
